import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\PortfolioController::select
* @see app/Http/Controllers/Admin/PortfolioController.php:57
* @route '/portfolio/select/{id}'
*/
export const select = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: select.url(args, options),
    method: 'post',
})

select.definition = {
    methods: ["post"],
    url: '/portfolio/select/{id}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\PortfolioController::select
* @see app/Http/Controllers/Admin/PortfolioController.php:57
* @route '/portfolio/select/{id}'
*/
select.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return select.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PortfolioController::select
* @see app/Http/Controllers/Admin/PortfolioController.php:57
* @route '/portfolio/select/{id}'
*/
select.post = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: select.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\PortfolioController::select
* @see app/Http/Controllers/Admin/PortfolioController.php:57
* @route '/portfolio/select/{id}'
*/
const selectForm = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: select.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\PortfolioController::select
* @see app/Http/Controllers/Admin/PortfolioController.php:57
* @route '/portfolio/select/{id}'
*/
selectForm.post = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: select.url(args, options),
    method: 'post',
})

select.form = selectForm

/**
* @see \App\Http\Controllers\Admin\PortfolioController::clear
* @see app/Http/Controllers/Admin/PortfolioController.php:68
* @route '/portfolio/clear'
*/
export const clear = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: clear.url(options),
    method: 'post',
})

clear.definition = {
    methods: ["post"],
    url: '/portfolio/clear',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\PortfolioController::clear
* @see app/Http/Controllers/Admin/PortfolioController.php:68
* @route '/portfolio/clear'
*/
clear.url = (options?: RouteQueryOptions) => {
    return clear.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PortfolioController::clear
* @see app/Http/Controllers/Admin/PortfolioController.php:68
* @route '/portfolio/clear'
*/
clear.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: clear.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\PortfolioController::clear
* @see app/Http/Controllers/Admin/PortfolioController.php:68
* @route '/portfolio/clear'
*/
const clearForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: clear.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\PortfolioController::clear
* @see app/Http/Controllers/Admin/PortfolioController.php:68
* @route '/portfolio/clear'
*/
clearForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: clear.url(options),
    method: 'post',
})

clear.form = clearForm

const portfolio = {
    select: Object.assign(select, select),
    clear: Object.assign(clear, clear),
}

export default portfolio